import type { TooltipProps } from 'recharts';
import { cn } from 'src/lib/utils';

type BetaChartTooltipProps = TooltipProps<number, string> & {
  valueFormatter?: (value: number, name?: string) => string;
  labelFormatter?: (label: string) => string;
};

const defaultValueFormatter = (value: number) =>
  Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 });

export function BetaChartTooltip({
  active,
  payload,
  label,
  valueFormatter = defaultValueFormatter,
  labelFormatter,
}: BetaChartTooltipProps) {
  if (!active || !payload?.length) {
    return null;
  }

  const displayLabel = labelFormatter && label != null ? labelFormatter(String(label)) : label;

  return (
    <div className="rounded-lg border border-[#E8E9ED] bg-white px-3 py-2.5 shadow-[0_4px_16px_rgba(13,15,26,0.10)]">
      {displayLabel ? (
        <p className="mb-1.5 text-[11px] font-bold uppercase tracking-[0.4px] text-[#8A8EA0]">
          {displayLabel}
        </p>
      ) : null}
      <div className="space-y-1">
        {payload.map((entry) => {
          if (entry.value == null) return null;
          const colour = entry.color ?? '#2563EB';
          return (
            <div key={entry.name} className="flex items-center justify-between gap-4">
              <span className="flex items-center gap-1.5 text-[12px] font-semibold text-[#5E6278]">
                <span
                  className="h-2 w-2 rounded-full"
                  style={{ backgroundColor: colour }}
                />
                {entry.name}
              </span>
              <span className={cn('text-[12px] font-bold tabular-nums text-[#0D0F1A]')}>
                {valueFormatter(Number(entry.value), entry.name)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export const BETA_CHART_TOOLTIP_CURSOR = { fill: 'rgba(37, 99, 235, 0.06)' };
